'use client';

import { type ReactNode, use } from 'react';
import type { RecentSearchCarouselItem } from './types/RecentSearchCarouselItem';

export type RecentSearchSliderProps = {
    recentSearches: Promise<RecentSearchCarouselItem[]>;
    children?: ReactNode;
};

export function RecentSearchCookieLoader({ recentSearches: recentSearchesIn, children }: RecentSearchSliderProps) {
    const recentSearches = use(recentSearchesIn);
    if (!recentSearches.length) {
        return null;
    }
    return children;
}
